export default "__VITE_ASSET__BkCjwL1E__"